var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 22 2)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-9.414 4.727a.937.937 0 0 0 1.324-1.324l-3.398-3.4 3.398-3.398a.937.937 0 0 0-1.324-1.324l-4.063 4.055a.934.934 0 0 0 0 1.324l4.063 4.067Z",
    fill: "#002FF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlue);
export default __webpack_public_path__ + "static/media/arrow-left-blue.8ee0a91b77fa0dedbe6ce9a532c12d8b.svg";
export { ForwardRef as ReactComponent };